import { motion, useScroll } from "framer-motion";
import Footer from "@/components/Footer";
import DemoHero from "./demo/DemoHero";
import DemoCeo from "./demo/DemoCeo";
import DemoWhyChoose from "./demo/DemoWhyChoose";
import DemoServices from "./demo/DemoServices";
import DemoLogos from "./demo/DemoLogos";
import DemoEvents from "./demo/DemoEvents";
import DemoInsights from "./demo/DemoInsights";
import DemoCta from "./demo/DemoCta";

interface DemoLandingProps {
  language: string;
}

const DemoLanding = ({ language }: DemoLandingProps) => {
  const { scrollYProgress } = useScroll();

  return (
    <main className="relative bg-[#FAFAF8]">
      <style>{`
        @keyframes demo-dash { to { stroke-dashoffset: -64; } }
        @keyframes demo-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .demo-marquee-track { animation: demo-marquee var(--marquee-duration, 32s) linear infinite; }
        .demo-marquee-reverse .demo-marquee-track { animation-direction: reverse; }
        .demo-marquee:hover .demo-marquee-track { animation-play-state: paused; }
        @media (prefers-reduced-motion: reduce) {
          .demo-marquee-track { animation: none; }
        }
      `}</style>

      {/* corridor-gradient scroll progress, under the fixed navbar */}
      <motion.div
        aria-hidden
        style={{ scaleX: scrollYProgress }}
        className="fixed inset-x-0 top-16 z-40 h-0.5 origin-left bg-gradient-to-r from-primary via-primary-light to-secondary"
      />

      {/* film grain over the whole page */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 z-30 opacity-[0.03] mix-blend-multiply"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
        }}
      />

      <DemoHero language={language} />
      <DemoCeo language={language} />
      <DemoWhyChoose language={language} />
      <DemoServices language={language} />
      <DemoLogos language={language} />
      <DemoEvents language={language} />
      <DemoInsights language={language} />
      <DemoCta language={language} />
      <Footer language={language} />

      {/* Demo marker — remove when promoting this design */}
      <div className="pointer-events-none fixed bottom-4 right-4 z-50 rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-xs font-medium text-amber-700 shadow-sm">
        Demo · full page redesign preview
      </div>
    </main>
  );
};

export default DemoLanding;
